<template lang="html">
  <div class="inner" :class="theClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    line: '',
    size: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    theClass() {
      let value = 'size-' + this.size;
      if (this.line) {
        value += ' line-' + this.line;
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
.inner {
  @for $i from 1 through 4 {
    &.size-#{$i} {
      padding: (size($i) * 2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/layout/inner.vue